/** InsCoder WANG.J 2026-07-15 B + Grid banner card popup trigger **/
(function () {
  function shouldIgnoreClick(target) {
    return Boolean(target.closest('a, button, input, select, textarea, summary, [aria-controls]'));
  }

  function openPopup(trigger) {
    var popupId = trigger.getAttribute('data-popup-target');
    if (!popupId) return;

    var modal = document.getElementById(popupId);
    if (!modal || typeof modal.show !== 'function') return;

    modal.show(trigger);
  }

  function bindPopupTrigger(trigger) {
    if (!trigger || trigger.dataset.popupBound === 'true') return;

    trigger.dataset.popupBound = 'true';

    trigger.addEventListener('click', function (event) {
      if (shouldIgnoreClick(event.target)) return;

      event.preventDefault();
      openPopup(trigger);
    });

    trigger.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      openPopup(trigger);
    });
  }

  function initPopupTriggers(container) {
    var scope = container || document;
    scope.querySelectorAll('[data-card-popup-trigger]').forEach(bindPopupTrigger);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPopupTriggers(document);
    });
  } else {
    initPopupTriggers(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initPopupTriggers(event.target);
  });
})();
/** InsCoder WANG.J 2026-07-15 E + Grid banner card popup trigger **/
